export function truncateNumber(num: number, decimals: number): string {
	const factor = Math.pow(10, decimals)

	return (Math.trunc(num * factor) / factor).toFixed(decimals).replace(/\.0+$/, '')
}
